// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Spinner_wrap__a5m-b","spinner":"Spinner_spinner__wtAMh","SpinnerLoader":"Spinner_SpinnerLoader__1pDMm"};